
import { toast } from "vue3-toastify";

export function useMixError() {
    function showErrors(res) {
    if (!res) return
    if (res?.status === 400) {
      toast.error("Ups! Error 400. Algo ha pasado. Intenta luego")
    } else if (res?.status === 401) {
      toast("La sesión ha caducado, serás redirigido al login")
      setTimeout(() => window.location.href = "/login", 3000)
    } else if (res?.status === 500) {
      toast.error("Ups! Error 500. Algo ha pasado. Intenta luego")
    } else if (res?.data?.responseCode < 0) {
      toast.error(res?.data?.responseMessage)
    } else {
      toast.error("Ups! Algo ha pasado. Intenta luego")
    }
  }
  const showSuccess = (message) => {
    toast.success(message)
  }

  const showError = (message) => {
    toast.error(message)
  }

  return {
    showErrors,
    showSuccess,
    showError
  }
}
